import React, { useEffect, useState } from 'react';

import { showMessage } from '../../../../helpers/message';
import infracoes_api from '../../../../api/infracoes_api';

// Components
import CertificadoEntregaComunicacaoEletronica from '../../FichaInfracao/components/CertificadoEntregaComunicacaoEletronica';

 
export default function ComprovanteEnvioEmailSeparado({ hash }) {
    const [infracao, setInfracao] = useState(null);

    useEffect(() => {
        infracoes_api.GetItemFiscalizacaoHash(hash)
            .then(({ data }) => setInfracao(data))
            .catch(error => showMessage("Erro", error?.message ?? "Não foi possível carregar o documento.", "error", null));
    }, [hash]);

    const notificacao = infracao?.notificacoesEmails?.find(x => x.status === "Confirmado");

    if (!infracao || !notificacao) return <></>;

    return (
        <div className="p-3">
            <CertificadoEntregaComunicacaoEletronica dadosExtracao={notificacao} dadosInfracao={infracao} />
        </div>
    );
}
